import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}
export function Accordion({
  title,
  children,
  defaultOpen = false
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border border-gray-200 rounded-2xl shadow-sm bg-white mb-6 overflow-hidden" data-id="element-266">
      <button className="w-full px-6 py-4 flex justify-between items-center bg-white hover:bg-gray-50 transition-colors" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-267">
        <h2 className="text-lg font-medium text-gray-900" data-id="element-268">{title}</h2>
        {isOpen ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-269" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-270" />}
      </button>
      {isOpen && <div className="px-6 py-4 border-t border-gray-200" data-id="element-271">{children}</div>}
    </div>;
}